export default __webpack_public_path__ + "static/media/film.b125a8bd.svg";